<template>
  <div>
    <EquipmentEditHeader v-if="isAdmin" data-cy="equipment-edit-header" />
    <EquipmentTable
      data-cy="equipment-table"
      @select="$emit('select', $event.data as Casings)"
    />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";
import { useCasings } from "@/composables/equipment/casings/casings";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Casings, Casings_Type_Enum } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
  includeTypes: Casings_Type_Enum[];
}>();

defineEmits<{
  (event: "select", equipment: Casings): void;
}>();

const casingSearch = useCasings(props.isAdmin, props.includeTypes);

provide("equipment", casingSearch);
</script>
